import { useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Section } from './section';
import { WA_QUERY_KEY, WhatsappCard } from './whatsapp-card';

/** Só conexões do próprio tenant. Serviços globais da instalação aparecem apenas no painel da plataforma. */
export function IntegrationsPage() {
  const qc = useQueryClient();
  return (
    <Section
      title="Integrações"
      description="Conexões da sua barbearia com serviços externos."
      actions={
        <Button variant="outline" size="sm" onClick={() => void qc.invalidateQueries({ queryKey: WA_QUERY_KEY })}>
          <RefreshCw aria-hidden /> Verificar de novo
        </Button>
      }
    >
      <div className="grid gap-4">
        <WhatsappCard />
      </div>
    </Section>
  );
}
